<template>
  <div class="left-nav">
    <el-menu :router="true" active-text-color="#fff" :default-active="activeMenu" :unique-opened="true" :collapse-transition="false">
      <!-- 一级菜单-->
      <el-submenu :index="item.id + ''" v-for="(item, index) in $store.state.user.newList" :key="index">
        <template slot="title"> {{ item.name }}</template>
        <el-menu-item :index="subitem.component" v-for="(subitem, index2) in item.children" :key="index2" @click="nameClick(index2)">
          <template slot="title">
            <div style="display:flex;align-items: center;"> {{ subitem.name }} <div class="dot" :style="serviceData.onlineOrNot == 0 ? { background: '#F56D6D' } : { background: 'green' }"
                v-if="serviceData && subitem.name == '会话'"></div>
            </div>
          </template>
        </el-menu-item>
      </el-submenu>
    </el-menu>
  </div>
</template>
<script>
import { getStatus } from '@/views/Service/chatApi'

export default {
  name: 'left-nav',
  data () {
    return {
      type: window.localStorage.getItem('userId'),
      serviceData: {}
    }
  },
  computed: {
    activeMenu () {
      const route = this.$route
      const {
        meta,
        path
      } = route
      console.log('meta.activeMenu', meta.activeMenu)
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu
      }
      // sessionStorage.removeItem('searchFlag')
      return path
    }
  },
  created () {
    this.activePath = window.localStorage.getItem('activePath')
    this.getStatus()
  },
  methods: {
    getStatus () {
      getStatus(window.localStorage.getItem('userId')).then(res => {
        console.log('获取客服消息状态')
        this.serviceData = res.data
      })
    },
    nameClick (val) {
      console.log('点击菜单跳转', val)
      sessionStorage.removeItem('searchFlag')
    }
  }
}
</script>
<style scoped lang="less">
@import 'index';

@deep: ~'>>>';

.dot {
  width: 8px;
  height: 8px;
  background: #F56D6D;
  border-radius: 50%;
  margin-right: 10px;
}
</style>
